<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="RPO Management" />
    </div>

    <!-- Search and Create new package -->
    <div class="row mb-2">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <b-form-input
              v-model="filter"
              type="search"
              class="form-control"
              placeholder="Search RPO"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showCreatePackageModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i
            >{{ $t("menuitems.administration.list.rpo.list.add") }}
          </button>
        </div>
      </div>
    </div>

    <!-- Packages Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allUsers"
        :fields="fields"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(role_name)="row">
          <span>{{ String(row.item.role_name).toUpperCase() }}</span>
        </template>

        <template #cell(created_at)="row">
          <span
            >{{ new Date(row.item.created_at).toLocaleDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(is_active)="row">
          <span :class="`badge ${getStatusClass(row.item.is_active)}`">{{
            row.item.is_active ? "Active" : "Disabled"
          }}</span>
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="info"
            class="m-1"
            @click="ShowManageDeviceModal(row.item)"
            :disabled="currentUserId === row.item.id"
          >
            Devices
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="showUserModifyModal(row.item)"
            :disabled="currentUserId === row.item.id"
          >
            Modify
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            v-show="row.item.is_active == 1"
            @click="deactivateUser(row.item.id)"
            :disabled="currentUserId === row.item.id"
          >
            Deactivate
          </b-button>
          <b-button
            size="sm"
            variant="success"
            class="m-1"
            v-show="row.item.is_active == 0"
            @click="activateUser(row.item.id)"
            :disabled="currentUserId === row.item.id"
          >
            Activate
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Create new package modal -->
    <b-modal
      id="create-new-rpo-modal"
      title="Raise Challan"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Create New RPO Account</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="cancelCreateNewRpoModal()"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="createNewUser">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label>First Name</label>
              <input
                placeholder="Enter First Name"
                v-model="createUserObj.firstName"
                type="text"
                pattern="[a-zA-Z]*"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Last Name</label>
              <input
                placeholder="Enter Last Name"
                v-model="createUserObj.lastName"
                type="text"
                pattern="[a-zA-Z]*"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Email ID</label>
              <input
                placeholder="Enter Email ID"
                v-model="createUserObj.email"
                type="email"
                pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Mobile Number</label>
              <input
                placeholder="Enter Mobile Number"
                v-model="createUserObj.mobile"
                type="text"
                maxlength="10"
                pattern="[1-9]{1}[0-9]{9}"
                class="form-control inp-bg"
                required=""
                oninvalid="this.setCustomValidity('Please Enter Valid Mobile Number')"
                onchange="try{setCustomValidity('')}catch(e){}"
                oninput="setCustomValidity(' ')"
              />
            </div>
          </div>
          <hr />
          <div class="col-6">
            <div class="mb-3">
              <label>Login Username</label>
              <input
                placeholder="Enter Login Username"
                v-model="createUserObj.username"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Login Password</label>
              <input
                placeholder="Enter Login Password"
                v-model="createUserObj.password"
                type="password"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>RPO Vehicle No.</label>
              <input
                v-model="createUserObj.vehicle_no"
                type="text"
                class="form-control inp-bg"
                required
                maxlength="10"
                style="text-transform: uppercase"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Select Package</label>
              <v-select
                class="style-chooser"
                v-model="createUserObj.packageId"
                :reduce="(pkg) => pkg.id"
                label="package_name"
                :options="allPackages"
                background-color="white"
                required
              ></v-select>
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Create User Account <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Update user package modal -->
    <b-modal
      id="update-rpo-modal"
      title="Raise Challan"
      title-class="font-18"
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Modify RPO Account</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('update-rpo-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="updateUser">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label>First Name</label>
              <input
                placeholder="Enter First Name"
                v-model="updateUserObj.first_name"
                type="text"
                pattern="[a-zA-Z]*"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Last Name</label>
              <input
                placeholder="Enter Last Name"
                v-model="updateUserObj.last_name"
                type="text"
                pattern="[a-zA-Z]*"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Email ID</label>
              <input
                placeholder="Enter Email ID"
                v-model="updateUserObj.email"
                type="email"
                pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Mobile Number</label>
              <input
                placeholder="Enter Mobile Number"
                v-model="updateUserObj.mobile"
                type="number"
                class="form-control inp-bg"
                pattern="[1-9]{1}[0-9]{9}"
                title="Please enter 10 digit mobile number"
                required
              />
            </div>
          </div>
          <hr />
          <div class="col-6">
            <div class="mb-3">
              <label>Login Username</label>
              <input
                placeholder="Enter Login Username"
                v-model="updateUserObj.username"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Login Password</label>
              <input
                placeholder="Enter Login Password"
                v-model="updateUserObj.password"
                type="password"
                class="form-control inp-bg"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>RPO Vehicle No.</label>
              <input
                placeholder="Enter Vehicle Number"
                v-model="updateUserObj.vehicle_no"
                type="text"
                class="form-control inp-bg"
                required
                maxlength="10"
                style="text-transform: uppercase"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label>Select Package</label>
              <v-select
                class="style-chooser"
                v-model="updateUserObj.packageId"
                :options="allPackages"
                background-color="white"
                placeholder="Select Package"
                :reduce="(pkg) => pkg.id"
                label="package_name"
                required
              ></v-select>
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Save User Details <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Update rpo device modal -->
    <b-modal
      id="update-rpo-device-modal"
      title-class="font-18"
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Manage Devices</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('update-rpo-device-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="updateDevices">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>Vehicle Front Camera</label>
              <input
                placeholder="Enter camera URL"
                v-model="updateDeviceObj.front_camera_url"
                type="text"
                class="form-control inp-bg"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label>Vehicle Rear Camera</label>
              <input
                placeholder="Enter camera URL"
                v-model="updateDeviceObj.rear_camera_url"
                type="text"
                class="form-control inp-bg"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label>Body Camera</label>
              <input
                placeholder="Enter camera URL"
                v-model="updateDeviceObj.body_camera_url"
                type="text"
                class="form-control inp-bg"
              />
            </div>
          </div>
        </div>
        <hr />
        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Save Devices <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import packageMixin from "@/mixins/administration";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "RPO Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [packageMixin],
  data() {
    return {
      createUserObj: {},
      updateUserObj: {},
      updateDeviceObj: {},
      allPackages: [],
      allUsers: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "first_name",
          label: "First Name",
          sortable: false,
        },
        {
          key: "last_name",
          label: "Last Name",
          sortable: false,
        },
        {
          key: "mobile",
          sortable: false,
        },
        {
          key: "package_name",
          sortable: false,
        },
        {
          key: "is_active",
          sortable: false,
        },
        {
          key: "vehicle_no",
          sortable: false,
        },
        {
          key: "created_at",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "",
        },
      ],
    };
  },
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    this.allPackages = await this.GetAllPackages();
    this.allUsers = await this.GetRPOUsers();
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
  methods: {
    showCreatePackageModal() {
      this.$bvModal.show("create-new-rpo-modal");
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    cancelCreateNewRpoModal() {
      this.createUserObj = {};
      this.$bvModal.hide("create-new-rpo-modal");
    },

    async createNewUser() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.CreateRPOUser(this.createUserObj);
        this.createUserObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("create-new-rpo-modal");
        this.allUsers = await this.GetRPOUsers();
        Swal.fire(
          "Account Created!",
          "RPO account created successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    async updateUser() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        if (typeof this.updateUserObj.packageId === "object")
          delete this.updateUserObj.packageId;

        await this.UpdateUser(this.updateUserObj);
        this.allUsers = await this.GetRPOUsers();
        this.updateUserObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("update-rpo-modal");
        Swal.fire(
          "Account Updated!",
          "RPO account updated successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    async updateDevices() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.SaveRPODevices(this.updateDeviceObj);
        this.allUsers = await this.GetRPOUsers();
        this.updateDeviceObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("update-rpo-device-modal");
        Swal.fire(
          "Devices Updated!",
          "RPO devices updated successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    showUserModifyModal(selectedUser) {
      this.updateUserObj = {
        id: selectedUser.id,
        first_name: selectedUser.first_name,
        last_name: selectedUser.last_name,
        email: selectedUser.email,
        mobile: selectedUser.mobile,
        username: selectedUser.username,
        vehicle_no: selectedUser.vehicle_no,
        packageId: this.allPackages.find(
          (ap) => ap.id === selectedUser.package_id
        ),
      };
      this.$bvModal.show("update-rpo-modal");
    },

    ShowManageDeviceModal(selectedUser) {
      this.updateDeviceObj = {
        user_id: selectedUser.id,
        front_camera_url: selectedUser.front_camera_url,
        rear_camera_url: selectedUser.rear_camera_url,
        body_camera_url: selectedUser.body_camera_url,
        vehicle_no: selectedUser.vehicle_no,
      };

      this.$bvModal.show("update-rpo-device-modal");
    },

    async deactivateUser(userId) {
      const payload = {
        id: userId,
        isActive: false,
      };

      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateUser(payload);
        this.allUsers = await this.GetRPOUsers();
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Account Deactivated!",
          "RPO account deactivated successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    async activateUser(userId) {
      const payload = {
        id: userId,
        isActive: true,
      };

      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateUser(payload);
        this.allUsers = await this.GetRPOUsers();
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Account Activated!",
          "RPO account activated successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },

    getStatusClass(status) {
      switch (status) {
        case true:
        case 1:
          return "bg-success";

        case false:
          return "bg-danger";

        default:
          return "bg-info";
      }
    },
  },
  computed: {
    currentUserId() {
      return this.$store.getters["auth/user"].user.id;
    },
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
